module.exports = __webpack_public_path__ + "static/favicon-42ea5e2185c681b79a9204af9a86997a.ico";